export default "__VITE_ASSET__3840b785__"